var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8L2.29683 7.1166C2.44374 7.0601 2.5172 7.03185 2.58592 6.99496C2.64696 6.96219 2.70515 6.92437 2.75989 6.8819C2.82151 6.83408 2.87716 6.77843 2.98846 6.66713L7.65712 1.99848C8.1143 1.5413 8.1143 0.800064 7.65713 0.342885C7.19995 -0.114294 6.45871 -0.114295 6.00153 0.342884L1.33287 5.01154C1.22157 5.12284 1.16592 5.17849 1.1181 5.24011C1.07563 5.29484 1.03781 5.35304 1.00504 5.41408C0.968152 5.4828 0.9399 5.55626 0.883396 5.70317L0 8ZM0 8L0.851852 5.78521C0.91281 5.62672 0.943288 5.54748 0.995566 5.51118C1.04125 5.47946 1.09778 5.46746 1.15241 5.4779C1.21493 5.48983 1.27496 5.54987 1.39504 5.66994L2.33007 6.60498C2.45014 6.72505 2.51018 6.78508 2.52212 6.8476C2.53255 6.90223 2.52055 6.95876 2.48883 7.00445C2.45253 7.05672 2.37329 7.0872 2.2148 7.14816L0 8Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.8ea4fd51f1a5caf78e591954d853e8f8.svg";
export { ForwardRef as ReactComponent };